// extracted by mini-css-extract-plugin
export default {"logoWrapper":"workspace-logo_logoWrapper__RMCB8"};